import type { PromotedProductsComponentProps } from './promoted-products.component';

/**
 * Maps HTML attribute names (kebab-case) to PromotedProductsComponent prop names (camelCase)
 */
export const PROMOTED_PRODUCTS_ATTRIBUTE_MAP: Record<string, keyof PromotedProductsComponentProps> =
  {
    display: 'display',
    'logged-in': 'loggedIn',
    'title-text': 'titleText',
    'title-size': 'titleSize',
    description: 'description',
    'column-count': 'columnCount',
    'max-width': 'maxWidth',
    'product-title-size': 'productTitleSize',
    'show-product-title': 'showProductTitle',
    'show-product-price': 'showProductPrice',
    'show-quick-add': 'showQuickAdd',
    'separate-tab': 'separateTab',
    'collection-handle': 'collectionHandle',
    'content-id': 'contentId',
    'section-background': 'sectionBackground',
    'text-color': 'textColor',
  };

/**
 * Properties that should be converted from string to boolean
 */
const BOOLEAN_PROPS = new Set([
  'loggedIn',
  'maxWidth',
  'showProductTitle',
  'showProductPrice',
  'showQuickAdd',
  'separateTab',
]);

/**
 * Converts a string attribute value to the appropriate type
 */
function convertAttributeValue(propName: string, value: string): any {
  if (BOOLEAN_PROPS.has(propName)) {
    // Convert string "true"/"false" to boolean
    return value === 'true';
  }
  return value;
}

/**
 * Extracts attributes from an HTMLElement and converts them to PromotedProductsComponent props
 */
export function extractPromotedProductsAttributes(
  element: HTMLElement
): Partial<PromotedProductsComponentProps> {
  const props: Partial<PromotedProductsComponentProps> = {};

  for (const [attrName, propName] of Object.entries(PROMOTED_PRODUCTS_ATTRIBUTE_MAP)) {
    const value = element.getAttribute(attrName);
    if (value !== null) {
      (props as any)[propName] = convertAttributeValue(propName, value);
    }
  }

  return props;
}
